import { render, staticRenderFns } from "./SetExperimentPage.vue?vue&type=template&id=1f9a22f8&scoped=true&lang=html&"
import script from "./SetExperimentPage.vue?vue&type=script&lang=js&"
export * from "./SetExperimentPage.vue?vue&type=script&lang=js&"
import style0 from "./SetExperimentPage.vue?vue&type=style&index=0&id=1f9a22f8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a22f8",
  null
  
)

export default component.exports